// Hotspot (Seu Hotspot) helpers and constants shared by the integration form.
import { i18n } from "../translate/i18n";

// Every key the Hotspot form keeps inside jsonContent.
export const HOTSPOT_JSON_FIELDS = [
  "baseUrl",
  "apiKey",
  "defaultDeviceId",
  "defaultTabela",
];

// defaultTabela options: prefer i18n.t(labelKey) at render time; `label` is a pt fallback
export const HOTSPOT_TABELAS = [
  { value: "", label: "—", labelKey: "hotspot.tabelas.none" },
  { value: "varejo", label: "Varejo", labelKey: "hotspot.tabelas.varejo" },
  { value: "atacado", label: "Atacado", labelKey: "hotspot.tabelas.atacado" },
];

const isValidUrl = (value) => {
  if (!value) return false;
  try {
    const url = new URL(value);
    return url.protocol === "http:" || url.protocol === "https:";
  } catch (e) {
    return false;
  }
};

export const validateHotspotConfig = (values) => {
  const errors = [];
  if (!values.name) errors.push(i18n.t("erp.validation.nameRequired"));
  if (!values.baseUrl) errors.push(i18n.t("erp.validation.hotspotBaseUrlRequired"));
  else if (!isValidUrl(values.baseUrl)) errors.push(i18n.t("erp.validation.urlInvalid"));
  if (!values.apiKey) errors.push(i18n.t("erp.validation.hotspotApiKeyRequired"));
  return errors;
};
